// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2Wc5-","header":"Messages_header__jukKu"};